// src 기반 preload 캐시 (드래그 시작 시 미리 로드)
const preloadCache = new Map<string, Promise<HTMLImageElement | null>>();

// src 기반 로드 완료 이미지 레지스트리 (미니맵 등에서 네트워크 없이 재사용)
const loadedRegistry = new Map<string, HTMLImageElement>();

export const imageCache = {
  preload: (src: string, loader: () => Promise<HTMLImageElement | null>) => {
    if (!preloadCache.has(src)) {
      preloadCache.set(src, loader());
    }
  },

  getPreloaded: (src: string): Promise<HTMLImageElement | null> | undefined =>
    preloadCache.get(src),

  clearPreload: (src: string) => {
    preloadCache.delete(src);
  },

  /** 로드 완료된 이미지를 src 기반으로 등록 (미니맵 등에서 재사용) */
  registerLoaded: (src: string, img: HTMLImageElement) => {
    if (src) loadedRegistry.set(src, img);
  },

  /** src로 이미 로드된 이미지 조회 */
  getLoaded: (src: string): HTMLImageElement | undefined =>
    loadedRegistry.get(src),
};
